import type { MedicalInfo } from "../../types/MedicalInfo"

export const MENTAL_HEALTH_PREFIX =
  "Over the last two weeks, how often have you been bothered by the following problems?"

export type MentalHealthScreenerField =
  | "mentalHealthInterest"
  | "mentalHealthMood"
  | "mentalHealthNervous"
  | "mentalHealthWorry"

export const MENTAL_HEALTH_ITEMS: Array<{ field: MentalHealthScreenerField; label: string }> = [
  { field: "mentalHealthInterest", label: "Little interest or pleasure in doing things" },
  { field: "mentalHealthMood", label: "Feeling down, depressed, or hopeless" },
  { field: "mentalHealthNervous", label: "Feeling nervous, anxious, or on edge" },
  { field: "mentalHealthWorry", label: "Not being able to stop or control worrying" }
]

export function hasMentalHealthScreenerAnswer(medicalInfo: MedicalInfo): boolean {
  return MENTAL_HEALTH_ITEMS.some(({ field }) => medicalInfo?.[field] != null)
}
